import { useQuery } from "@tanstack/react-query";
import { PublicObjectBrief } from "@/types";
import {
  fetchGoalBrief,
  fetchSignalBrief,
  fetchFeedbackBrief,
  fetchTechnologyBrief,
  fetchActionItemBrief,
} from "@/services/frontendServices/objectBriefServices";

export const briefKeys = {
  goals: (accountId: string) => ["briefs", "goals", accountId] as const,
  signals: (accountId: string) => ["briefs", "signals", accountId] as const,
  feedback: (accountId: string) => ["briefs", "feedback", accountId] as const,
  technology: (accountId: string) =>
    ["briefs", "technology", accountId] as const,
  actionItems: (accountId: string) =>
    ["briefs", "action-items", accountId] as const,
};

export function useGoalBrief(accountId: string) {
  return useQuery<PublicObjectBrief | null, Error>({
    queryKey: briefKeys.goals(accountId),
    queryFn: () => fetchGoalBrief(accountId),
    enabled: !!accountId,
  });
}

export function useSignalBrief(accountId: string) {
  return useQuery<PublicObjectBrief | null, Error>({
    queryKey: briefKeys.signals(accountId),
    queryFn: () => fetchSignalBrief(accountId),
    enabled: !!accountId,
  });
}

export function useFeedbackBrief(accountId: string) {
  return useQuery<PublicObjectBrief | null, Error>({
    queryKey: briefKeys.feedback(accountId),
    queryFn: () => fetchFeedbackBrief(accountId),
    enabled: !!accountId,
  });
}

export function useTechnologyBrief(accountId: string) {
  return useQuery<PublicObjectBrief | null, Error>({
    queryKey: briefKeys.technology(accountId),
    queryFn: () => fetchTechnologyBrief(accountId),
    enabled: !!accountId,
  });
}

export function useActionItemBrief(accountId: string) {
  return useQuery<PublicObjectBrief | null, Error>({
    queryKey: briefKeys.actionItems(accountId),
    queryFn: () => fetchActionItemBrief(accountId),
    enabled: !!accountId,
  });
}
